import { render, staticRenderFns } from "./advertoauth-add-or-update.vue?vue&type=template&id=3f7ce1bd&"
import script from "./advertoauth-add-or-update.vue?vue&type=script&lang=js&"
export * from "./advertoauth-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports